import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=c949b210"
import script from "./questions.vue?vue&type=script&lang=ts"
export * from "./questions.vue?vue&type=script&lang=ts"
import style0 from "./questions.vue?vue&type=style&index=0&id=c949b210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports